import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const AIGCardContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;
